import { FvButton } from '@fv/client-components'
import type { Quote } from '@fv/client-types'
import type { Workflow } from '@fv/models'

import { useCarrierPublicSettings } from '@/hooks/useCarrierPublicSettings'

import { useCanSchedulePickup } from '../book/useCanSchedulePickup'
import type { LoadHandlingUnitFormModel } from '../commodities/load-items/types'
import type { ShipmentLocationFormModel } from '../shipment-location-form/types'
import { getBookActionLabel } from './utils'

type Props = {
  onPrintBOL?: () => void
  items: LoadHandlingUnitFormModel[]
  locations: ShipmentLocationFormModel[]
  workflow: Workflow
  quote: Quote
  isLoading: boolean
}
export const ShipmentBookActions = ({
  onPrintBOL,
  items,
  locations,
  workflow,
  quote,
  isLoading,
}: Props) => {
  const canSchedulePickup = useCanSchedulePickup({
    isFreightCollect: false,
    items,
    locations,
    workflow,
    selectedQuote: quote,
  })
  const carrierSettings = useCarrierPublicSettings(quote.carrierId)
  const submitLabel = getBookActionLabel(workflow)

  return (
    <>
      {!!onPrintBOL && carrierSettings.carrierPublicSettings?.allowBolOnly && (
        <FvButton
          theme="default"
          icon="check"
          onClick={onPrintBOL}
          loading={isLoading}
        >
          Print BOL
        </FvButton>
      )}
      {canSchedulePickup && (
        <FvButton
          type="submit"
          theme="primary"
          icon="check"
          fwd
          loading={isLoading}
        >
          {submitLabel}
        </FvButton>
      )}
    </>
  )
}
